import styled from 'styled-components';
import avatarImg from './assets/avatar.png';

const S = {
  Container: styled.div`
    position: absolute;
    top: 48%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  `,
  Icon: styled.div`
    margin: auto;
    width: 5.5rem;
    height: 5.5rem;
    background-image: url(${avatarImg});
    background-size: cover;
  `,
  Text: styled.div`
    text-align: center;
    font-family: 'Dogica', sans-serif;
    font-size: 0.9rem;
  `,
};

export const FirstVisitView = ({ onLaunch }: { onLaunch?: () => void }) => {
  return (
    <S.Container onClick={onLaunch}>
      <S.Icon />
      <S.Text>SIJIA.exe</S.Text>
    </S.Container>
  );
};
